import axios from 'axios';
import { config } from '@surgia/config';

// Create axios instance with interceptors
const apiClient = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout,
  headers: {
    ...config.api.headers
  }
});

// Single request interceptor (auth + logging)
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    if (error.response?.status === 401) {
      // Dispatch custom event when 401 occurs
      window.dispatchEvent(new CustomEvent('auth:logout', {
        detail: {
          reason: 'unauthorized',
          timestamp: new Date().toISOString()
        }
      }));
    }
    return Promise.reject(error);
  }
);

// Single response interceptor (auth + logging + error handling)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.error('Response error:', error);
    // Handle 401 - refresh token
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('auth:logout', {
        detail: {
          reason: 'unauthorized',
          timestamp: new Date().toISOString()
        }
      }));
    }
    
    return Promise.reject(error);
  }
);

export { apiClient }; 